export default {
      id: "Icon--animal-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#Icon--animal",
      toString: function () {
        return this.url;
      }
    }